<template>
  <section class="app-main">
    <!-- <transition v-if='showAnim' name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key"/>
      </keep-alive>
    </transition> -->

    <!-- <keep-alive> -->
    <!-- <router-view :key="key"/> -->
    <!-- </keep-alive> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AppMain',

  computed: {
    ...mapGetters(['showAnim']),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    },
  },
}
</script>

<style scoped>
.app-main {
  /*84 = navbar + tags-view + app-bottom = 50 +34 + 34 */
  min-height: calc(100vh - 118px);
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #f3f3f3;
  padding: 10px;
}
</style>

